<template>
  <div class="modal fade" tabindex="-1" :id="id">
    <div class="modal-dialog">
      <form @submit.prevent="updateReason" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"> {{ $t('reason.update.title') }} </h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor" />
                </svg>
              </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />
            <div class="row">
              <Input
                  container-class="col-12 form-group mb-5"
                  name="reason-name"
                  :label="$t('reason.label.name')"
                  labelClass="form-label fs-6 text-black"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  :isRequired="true"
                  size="lg"
                  :min="1"
                  v-model="formData.name"
              />
              <div class="mb-5">
                <label class="form-label fs-6 fw-bolder text-black"> {{ $t('reason.label.type') }} </label>
                <template
                    v-for="(type, index) in types"
                    :key="type.id">
                  <div class="form-check form-check-custom form-check-solid mb-3">
                    <input
                        type="checkbox"
                        class="form-check-input"
                        name="input-type"
                        :value="type.id"
                        :id="'input-type'+index"
                        v-model="formData.type">
                    <label class="form-check-label" :for="'input-type'+index">{{ type[locale] }}</label>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" btn-class="btn-sm me-2" btn-text="button.cancel" @click.prevent="cancel" size="7px 30px"></Button>
            <Button type="submit" btn-class="btn-sm me-2" btn-text="button.save" size="7px 30px" :isDisabled="submitting" :isLoading="submitting"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>

import RequiredText from "@/components/RequiredText.vue";
import Button from "@/components/Button.vue";
import Input from "@/components/Input.vue";

import {computed, defineProps, ref, watch} from 'vue'
import {useStore} from "vuex";
import i18n from "@/plugins/i18n";
import {useLocales} from "@/composables/locales";

const { locale } = useLocales()
const store = useStore()
const props = defineProps({
  id: {type: String, required: true},
  parentId: String,
  reason: {
    type: String,
    default: () => ({
      name: '',
      type: [],
    })
  }
})
const emits = defineEmits('reloadDatatable')
const submitting = ref(false)
const formData = ref(props.reason)

const types = computed(() => store.getters['reason/reasonTypes'])

watch(() => props.reason , value => formData.value = value , { deep : true} )

const cancel = () => {
  if(props.parentId) {
    $(props.parentId).modal('toggle')
  }
  $('#'+props.id).modal('toggle')
}
const updateReason = () => {
  submitting.value = true
  store.dispatch('reason/updateReason', formData.value)
      .then(res => {
        emits('afterCreate')
        window.toastr['success'](i18n.global.t('setting.notification.reason_updated'))
        formData.value = {
          name: '',
          type: [],
        }
        cancel()
      })
      .catch(err => {

      })
      .finally(() => submitting.value = false)
}
</script>


<style scoped>

</style>
